<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="房源" name="0"></el-tab-pane>
            <el-tab-pane label="房东" name="1"></el-tab-pane>
            <el-tab-pane label="导游" name="2"></el-tab-pane>
            <el-tab-pane label="景区" name="3"></el-tab-pane>
            <el-tab-pane label="温泉" name="4"></el-tab-pane>
            <el-tab-pane label="美食" name="5"></el-tab-pane>
        </el-tabs>
        <div class="list-content" v-loading="loading">
            <div class="list-item" v-for="(item,index) in list" :key="index" @click="toDetail(item.shop_id)">
                <img :src="`/api/v1/file/${item.cover||item.portrait}`" class="list-item-img" alt="">
                <div>
                    <div class="item-title">{{item.title}}</div>
                    <el-rate :value="+item.star|| 0"
                             disabled
                             show-score
                             disabled-void-color="#cccccc"
                             text-color="#ff9900"
                             style="display: flex;justify-content: flex-start;align-items: center"
                             score-template="{value}"></el-rate>
                    <div class="item-text" v-html="item.assess.replace(/\n/g,'<br/>')"></div>
                </div>
            </div>

            <el-alert v-if="list.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    export default {
        name: "myEvaluate",
        data() {
            return {
                loading: false,
                activeName: '0',
                list: []
            }
        },
        created() {
            this.myEvaluate();
        },
        methods: {
            handleClick(tab) {
                this.myEvaluate();
            },
            async myEvaluate() {
                this.loading = true;
                let [e, data] = await this.$api.myEvaluateApi({state: this.activeName})
                this.loading = false;
                this.list = data.result.evaluates;
            },
            toDetail(id) {
                let path = '';
                if (this.activeName === '0') {
                    path = '/houseDetail'
                } else if (this.activeName === '1') {

                } else if (this.activeName === '2') {

                } else if (this.activeName === '3') {
                    path = '/sceneDetail'
                } else if (this.activeName === '4') {
                    path = '/hotSpringDetail'
                } else if (this.activeName === '5') {
                    path = '/cateDetail'
                }
                this.$router.push({path, query: {id}})
            }
        },
    }
</script>

<style scoped lang="less">
    .list-content {
        .list-item {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 10px 0;
            box-sizing: border-box;
            border-bottom: 1px solid #e2e2e2;
            cursor: pointer;

            &:last-child {
                border-bottom: none;
            }

            .list-item-img {
                width: 100px;
                height: 100px;
                border-radius: 6px;
                margin-right: 16px;
                object-fit: cover;
            }

            .item-title {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 6px;
                text-align: left;
            }

            .item-text {
                font-size: 14px;
                margin-top: 6px;
                color: #949494;
                text-align: left;
                line-height: 1.5;
            }
        }
    }
</style>
